import React from 'react';

const Profile = () => {
  return <div>PROFILE</div>;
};

export default Profile;
